<template>
  <div class="content-v2">
    <div class="culture-grid-v2">
      <div class="culture-item" v-for="(item, i) in displayCultureList" :key="i">
        <div class="item-num">0{{ i + 1 }}</div>
        <h4>{{ item.title }}</h4>
        <p>{{ item.desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getCultureList } from '@/api/portal'

export default {
  name: 'AboutCultureV2',
  data() {
    return {
      cultureList: [
        { title: '企业愿景', desc: '铸造智慧电力，开创清洁能源。' },
        { title: '企业宗旨', desc: '聚天下英才，创智慧未来。' },
        { title: '企业使命', desc: '打造电力行业一站式综合服务平台。' },
        { title: '核心价值观', desc: '诚信、激情、创新、和谐。' }
      ]
    }
  },
  created() {
    getCultureList().then(list => {
      if (list && list.length) {
        this.cultureList = list.map(item => ({
          title: item.cultureTitle,
          desc: item.cultureContent
        }))
      }
    }).catch(() => {})
  },
  computed: {
    displayCultureList() {
      if (this.$langState.locale === 'en') {
        return [
          { title: 'Vision', desc: 'Build smart power and create clean energy.' },
          { title: 'Purpose', desc: 'Gather talents and create a smart future.' },
          { title: 'Mission', desc: 'Build an integrated service platform for the power industry.' },
          { title: 'Values', desc: 'Integrity, passion, innovation and harmony.' }
        ]
      }
      return this.cultureList
    }
  }
}
</script>

<style lang="scss" scoped>
.culture-grid-v2 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.culture-item {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 40px 32px;
  transition: all 0.4s;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 16px 40px rgba(0,0,0,0.08);
    border-color: transparent;
  }

  .item-num {
    font-size: 48px;
    font-weight: 800;
    background: linear-gradient(135deg, #3b82f6, #06b6d4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 16px;
  }

  h4 {
    font-size: 20px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
  }

  p {
    font-size: 15px;
    color: #64748b;
    line-height: 1.8;
  }
}

@media (max-width: 960px) {
  .culture-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .culture-grid-v2 {
    grid-template-columns: 1fr;
  }
}
</style>
